import styles from './ErrorMessage.module.scss';

interface ErrorMessagePros {
  errorMessage?: string;
}

export const ErrorMessage = ({ errorMessage = null }: ErrorMessagePros) => {
  return <span className={styles.root}>{errorMessage}</span>;
};
